/**
 * Default SPA path after successful authentication.
 * Keep in sync with Login / MFA post-login navigation.
 */
export function getDefaultRouteForRole(role) {
    if (!role) return "/home";
    if (role === "admin") return "/home";
    if (
        role === "Counsellor" ||
        role === "Visa Counsellor" ||
        role === "Visa&Application Counsellor"
    ) {
        return "/counsellor-dashboard";
    }
    if (role === "Receptionist") return "/create-enquiry";
    if (role === "Back Office") return "/all-enquiry";
    if (role === "Lecturer") return "/schedule";
    if (role === "Accountant" || role === "Accounts") return "/accounts-dashboard";
    if (role === "Manager") return "/all-enquiry";
    return "/home";
}
